"use client";

import { SelectField } from "@/components/tool-kit/primitives";
import { QuantityField } from "@/components/tools/physics-mechanics/quantity-field";
import { t } from "@/lib/i18n/interpolate";
import type {
  GravityPreset,
  GravityState,
} from "@/lib/tool-kit/physics-mechanics/gravity";
import {
  ACCELERATION,
  unitOptions,
} from "@/lib/tool-kit/physics-mechanics/units";

export interface GravityLabels {
  label: string;
  earth: string;
  moon: string;
  mars: string;
  custom: string;
  customLabel: string;
  unitFor: string;
}

const PRESETS: readonly GravityPreset[] = ["earth", "moon", "mars", "custom"];

/** A menu of bodies (Earth, Moon, Mars) plus an "another value" box. */
export function GravityPicker({
  idPrefix,
  state,
  onChange,
  labels,
  invalid = false,
}: {
  idPrefix: string;
  state: GravityState;
  onChange: (state: GravityState) => void;
  labels: GravityLabels;
  invalid?: boolean;
}) {
  return (
    <>
      <SelectField
        id={`${idPrefix}-gravity`}
        label={labels.label}
        onChange={(preset) => onChange({ ...state, preset })}
        options={PRESETS.map((preset) => ({
          value: preset,
          label: labels[preset],
        }))}
        value={state.preset}
      />
      {state.preset === "custom" ? (
        <QuantityField
          id={`${idPrefix}-gravity-custom`}
          invalid={invalid}
          label={labels.customLabel}
          onUnit={(unit) =>
            onChange({ ...state, custom: { ...state.custom, unit } })
          }
          onValue={(value) =>
            onChange({ ...state, custom: { ...state.custom, value } })
          }
          unit={state.custom.unit}
          unitLabel={t(labels.unitFor, { name: labels.customLabel })}
          units={unitOptions(ACCELERATION)}
          value={state.custom.value}
        />
      ) : null}
    </>
  );
}
